import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HttpClientModule } from '@angular/common/http';
import { HttpInteceptorModule } from './http/http-interceptor.module';

import { MaterialsModule } from '@library/common/materials';
import { PipesModule } from '@library/core/pipes';
import { ErrorsModule } from '@library/modules/errors';

import { NgxCaptchaModule } from 'ngx-captcha';

import { AppRouterModule } from './app.router.module';

import { AppComponent } from './app.component';

import { AccountComponent } from './account/account.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { PayComponent } from './pay';
import { TemplateComponent } from './template';
import { CheckoutComponent } from './checkout';

@NgModule({
   declarations: [
      AppComponent,
      AccountComponent,
      ConfirmationComponent,
      PayComponent,
      TemplateComponent,
      CheckoutComponent,
   ],
   imports: [
      BrowserModule,
      BrowserAnimationsModule,

      FormsModule, ReactiveFormsModule,

      HttpClientModule,
      HttpInteceptorModule,

      NgxCaptchaModule,

      MaterialsModule,
      PipesModule,
      ErrorsModule,

      AppRouterModule,
   ],
   bootstrap: [ AppComponent ]
})
export class AppModule { }
